import {
  REQUEST_GET_MISSION_BY_ID,
  SET_EXPERTISE_MISSION,
  REQUEST_READ_MISSION,
} from 'containers/ExpertAssignedMissionShow/constants';

export const setExpertiseMissionAction = (payload: any) => ({
  type: SET_EXPERTISE_MISSION,
  payload,
});

export const getMissionByIdAction = (payload: any) => ({
  type: REQUEST_GET_MISSION_BY_ID,
  payload,
});
export const requestReadMission = (payload: any) => ({
  type: REQUEST_READ_MISSION,
  payload,
});
